import { orgAPI } from "@/api/api";
import { IntegrationConnection } from "@cohesive/api-client";
import type { Entity } from "@cohesive/api-entities";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

interface UseAsanaMCPTeamsProps {
  connection: IntegrationConnection;
  workspaceGid?: string;
  options?: Partial<UseQueryOptions<Entity[], Error>>;
}

export function useAsanaMCPTeams({
  connection,
  workspaceGid,
  options = {},
}: UseAsanaMCPTeamsProps) {
  return useQuery<Entity[], Error>({
    queryKey: ["asana-mcp-teams", connection.id, workspaceGid],
    queryFn: async () => {
      if (!workspaceGid) return [];

      const response = await orgAPI.toolbox.execute<Entity[]>({
        integration_connection_id: connection.id,
        action_name: "asana-mcp-get-teams-for-workspace",
        action_input: { workspace_gid: workspaceGid },
      });
      return response.data;
    },
    enabled: !!connection.integration_id && !!workspaceGid,
    staleTime: 1000 * 60 * 5, // 5 minutes
    ...options,
  });
}
